
import React from 'react';
import { Link } from 'react-router-dom';

const CheckIcon = () => <span className="text-green-500 text-center text-lg">✔</span>;
const MinusIcon = () => <span className="text-gray-400 text-center text-lg">-</span>;

const SubscriptionGuide = () => {
  const plans = [
    {
      name: 'フリー',
      price: '0円',
      overage: '120円(税別)',
      invoiceLimit: '5',
      invoiceIssuance: true, 
      scheduledInvoice: true,
      history: false,
      customerUpload: false,
      customerDelete: false,
      teamManagement: false,
      activity: false,
    },
    {
      name: 'ライト',
      price: '1,000円(税別)',
      overage: '100円(税別)',
      invoiceLimit: '30',
      invoiceIssuance: true, 
      scheduledInvoice: true,
      history: true,
      customerUpload: true,
      customerDelete: true,
      teamManagement: false,
      activity: false,
    },
    {
      name: 'スタンダード',
      price: '3,000円(税別)',
      overage: '60円(税別)',
      invoiceLimit: '100',
      invoiceIssuance: true, 
      scheduledInvoice: true,
      history: true,
      customerUpload: true,
      customerDelete: true,
      teamManagement: true,
      activity: true,
    },
    {
      name: 'ビジネス',
      price: '8,000円(税別)',
      overage: '30円(税別)',
      invoiceLimit: '300',
      invoiceIssuance: true, 
      scheduledInvoice: true,
      history: true,
      customerUpload: true,
      customerDelete: true,
      teamManagement: true,
      activity: true,
    },
  ];

  const features = [
    { key: 'price', name: '基本料金' },
    { key: 'overage', name: '上限超過料金単価' },
    { key: 'invoiceLimit', name: '請求書発行上限' },
    { key: 'invoiceIssuance', name: '請求書発行' },
    { key: 'scheduledInvoice', name: '請求書予約発行' },
    { key: 'history', name: '請求履歴' },
    { key: 'customerUpload', name: '顧客アップロード' },
    { key: 'customerDelete', name: '顧客削除' },
    { key: 'teamManagement', name: 'チーム管理' },
    { key: 'activity', name: 'アクティビティ' },
  ];

  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        使い方 - ご契約内容
      </h1>
      <p className="text-lg text-gray-800 mb-6">
        「ご契約内容」では、現在のプラン状況や請求見込みを確認し、プラン変更などの操作を行うことができます。
      </p>

      <hr className="my-8 border-gray-200" />

      {/* Section 1: Your Plan */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">ご契約プラン</h2>
        <p className="mb-4 text-gray-700">現在の契約状況および利用状況を確認できます。</p>
        <ul className="list-none space-y-4 bg-gray-50 p-6 rounded-lg border border-gray-200">
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">現在の契約プラン:</strong>
            <span className="flex-1">現在ご利用中のプランです。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">次回適用予定プラン:</strong>
            <span className="flex-1">現在の利用期間終了後に適用されるプランです。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">今月の請求書発行枚数:</strong>
            <span className="flex-1">対象期間内に発行された請求書の枚数です。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">プラン上限:</strong>
            <span className="flex-1">基本料金内で発行できる請求書の上限枚数です。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">プラン超過分:</strong>
            <span className="flex-1">上限を超えた請求書の枚数です。超過分は従量課金の対象となります。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">対象期間:</strong>
            <span className="flex-1">現在のプランの適用期間です。期間内は上限枚数まで基本料金でご利用いただけます。</span>
          </li>
        </ul>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 2: Estimated Bill */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">今月の請求予定金額</h2>
        <p className="mb-4 text-gray-700">現在の利用状況に基づいた請求見込み金額を確認できます。</p>
        <ul className="list-none space-y-4 bg-gray-50 p-6 rounded-lg border border-gray-200">
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">プラン基本料金:</strong>
            <span className="flex-1">ご契約プランの月額料金です。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">超過分従量課金:</strong>
            <span className="flex-1">上限を超えた利用分に対する追加料金です。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">今月の請求予定金額:</strong>
            <span className="flex-1">現時点での合計請求見込み金額です。</span>
          </li>
          <li className="flex items-start">
            <strong className="font-semibold text-gray-900 w-56 flex-shrink-0 pr-4">対象期間:</strong>
            <span className="flex-1">請求対象となる契約期間です。</span>
          </li>
        </ul>
      </section>

      <hr className="my-8 border-gray-200" />
      
      {/* Section 3: Plan Descriptions */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">プランの説明</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-600 border-collapse">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100">
              <tr>
                <th className="py-3 px-4 border border-gray-200 w-1/4"></th>
                {plans.map(plan => <th key={plan.name} className="py-3 px-4 border border-gray-200 text-center">{plan.name}</th>)}
              </tr>
            </thead>
            <tbody>
              {features.map(feature => (
                <tr key={feature.key} className="bg-white border-b">
                  <td className="py-3 px-4 border border-gray-200 font-semibold">{feature.name}</td>
                  {plans.map(plan => (
                    <td key={`${plan.name}-${feature.key}`} className="py-3 px-4 border border-gray-200 text-center">
                      {typeof plan[feature.key] === 'boolean' 
                        ? (plan[feature.key] ? <CheckIcon /> : <MinusIcon />) 
                        : plan[feature.key]
                      }
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <hr className="my-8 border-gray-200" />

      {/* Section 4: Changing Plans */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">プランの変更</h2>
        <p className="mb-4 text-gray-700">
          初期状態ではフリープランが設定されています。<br />
          各プランの「プラン変更」ボタンから変更が可能です。
        </p>
        
        <div className="mb-6">
          <h3 className="text-xl font-semibold text-gray-700 mb-2">上位プランへの変更</h3>
          <p className="text-gray-700">変更後、即時適用されます。</p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold text-gray-700 mb-2">下位プランへの変更</h3>
          <p className="text-gray-700">現在の対象期間終了後に適用されます。</p>
        </div>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
          <p className="font-bold">注意</p>
          <ul className="list-disc list-inside mt-2">
            <li>フリープラン以外は有料プランです。</li>
            <li>事前に「設定」→「お客様情報」からクレジットカードの登録が必要です。</li>
            <li>上位プランへ変更後は、対象期間終了まで下位プランへ戻すことはできません。</li>
          </ul>
        </div>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-2">変更例</h3>
        <div className="bg-gray-100 p-4 rounded-lg border border-gray-200 mb-6">
          <p className="font-semibold text-gray-800">上位変更（即時反映）</p>
          <p className="text-gray-600 pl-2">例：ライト → スタンダード → 即時スタンダード適用</p>
          <p className="font-semibold text-gray-800 mt-4">下位変更（次期間から反映）</p>
          <div className="text-gray-600 pl-2">
            <p>例：</p>
            <ul className="list-disc list-inside pl-4">
              <li>対象期間：2026年5月10日～2026年6月9日</li>
              <li>→ 下位プランに変更した場合</li>
              <li>→ 2026年6月10日から新プラン適用</li>
            </ul>
          </div>
        </div>

        <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-800 p-4" role="alert">
          <p className="font-bold">ヒント</p>
          <p>対象期間の途中でプラン変更した場合、変更後のプラン料金が適用されます。<br/>超過料金が多い場合は、上位プランに変更した方が総額が安くなる可能性があります。</p>
        </div>
      </section>

      <div className="mt-8 text-center">
        <Link 
          to="/app/support/how-to-use"
          className="inline-block bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-lg transition-colors"
        >
          「使い方」一覧へ戻る
        </Link>
      </div>

    </div>
  );
};

export default SubscriptionGuide;
